export type Coordinates = {
    longitude: number;
    latitude: number;
};

export type GeolocationPoint = {
    middlePoint: Coordinates;
};

export type GeolocationArea = GeolocationPoint & {
    boundingBox: {
        southWest: Coordinates;
        southEast: Coordinates;
        northEast: Coordinates;
        northWest: Coordinates;
    };
};

export type GeolocationBoundariesPolygon = {
    type: 'Polygon';
    coordinates: Array<Array<Coordinates>>;
};

export type GeolocationBoundariesMultiPolygon = {
    type: 'MultiPolygon';
    coordinates: Array<Array<Array<Coordinates>>>;
};

export type GeolocationBoundaries =
    | GeolocationBoundariesPolygon
    | GeolocationBoundariesMultiPolygon;

function coordinatesCenter(coordinatesArray: Array<Coordinates>): [number, number] {
    return coordinatesArray
        .reduce(
            ([accLng, accLat], { longitude, latitude }) => {
                return [accLng + longitude, accLat + latitude];
            },
            [0, 0],
        )
        .map((coordinates) => {
            return coordinates / coordinatesArray.length;
        }) as [number, number];
}

export function polygonCenter(polygon: GeolocationBoundariesPolygon): [number, number] {
    return coordinatesCenter(polygon.coordinates[0]);
}

export function multiPolygonCenter(
    multiPolygon: GeolocationBoundariesMultiPolygon,
): [number, number] {
    return multiPolygon.coordinates[0]
        .reduce(
            ([accLng, accLat], coordinates) => {
                const [currentLng, currentLat] = coordinatesCenter(coordinates);

                return [accLng + currentLng, accLat + currentLat];
            },
            [0, 0],
        )
        .map((coordinates) => {
            return coordinates / multiPolygon.coordinates[0].length;
        }) as [number, number];
}
